import { Cable, ChevronRight } from "lucide-react";
import { Badge } from "@/shared/ui/badge";
import { ServiceLine } from "@/shared/types/serviceLineTypes";
import { Card } from "@/shared/ui/card";
import { getServiceLineStatusBGColorClass, getServiceLineTypeBGColorClass, SERVICE_LINE_STATUS_VALUE, SERVICE_LINE_TYPE_VALUES } from "@/shared/utils/color-utils-service-lines";

export function ServiceLinesSection({ serviceLines, onManageServiceLine }: { serviceLines?: ServiceLine[], onManageServiceLine: (serviceLine: ServiceLine) => void }) {
  return (
    <>
      {serviceLines && serviceLines.length > 0 && (
        <div className="space-y-2">
          <span className="text-sm font-medium">Associated Service Line{serviceLines.length > 1 ? 's' : ''} ({serviceLines.length})</span>
          <div className={`grid lg:grid-cols-${serviceLines.length > 1 ? '2' : '1'} grid-cols-1 gap-4`}>
            {serviceLines.map((serviceLine) => {
              const status = serviceLine.status;
              const type = serviceLine.type;
              return (
                <Card key={serviceLine.serviceLineNumber} className={`border border-border rounded-lg p-3 ${onManageServiceLine ? 'cursor-pointer' : ''}`}
                  onClick={() => onManageServiceLine && onManageServiceLine(serviceLine)}
                >
                  <div className="flex items-center justify-between h-full">
                    <div className="flex items-center gap-2">
                      <Cable className="h-4 w-4" />
                      <div className="flex flex-col">
                        <p className="text-sm font-semibold">{serviceLine.serviceLineName}</p>
                        <p className="text-sm">{serviceLine.serviceLineNumber}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      {type && (
                        <Badge variant="default" className={`${getServiceLineTypeBGColorClass(type)}`}>{SERVICE_LINE_TYPE_VALUES[type]}</Badge>
                      )}
                      {status && (
                        <Badge variant="default" className={`${getServiceLineStatusBGColorClass(status)}`}>{SERVICE_LINE_STATUS_VALUE[status]}</Badge>
                      )}
                      {onManageServiceLine && <ChevronRight className="h-6 w-6" />}
                    </div>
                  </div>
                </Card>
              )
            })}
          </div>
        </div>
      )}
    </>
  );
}